<template>
    <div class="cpo">
        <cmp-cpo-header class="cpo--header" :content="header"></cmp-cpo-header>
        <ul class="u-reset cpo--sections">
            <li v-for="(section, sectionIdx) in sections" class="cpo--section">
                <cmp-cpo-section :content="section" :idx="sectionIdx"
                        :is-first="sectionIdx === 0"
                        :is-last="sectionIdx === sections.length - 1">
                </cmp-cpo-section>
            </li>
        </ul>
        <cmp-cpo-cta class="cpo--cta" v-if="cta" :cta="cta"></cmp-cpo-cta>
        <cmp-cpo-footer class="cto--footer" :content="footer"></cmp-cpo-footer>
    </div>
</template>

<script>
    export default {
        props: {
            header: Object,
            sections: Array,
            cta: Object,
            footer: Object,
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?0c5430a0